
import { IResult } from "@/types/map";
import { Vue, Component, Prop } from "vue-property-decorator";
import DrawOverlaysBD from "../../DrawOverlays/bd/DrawOverlaysBD";
import GeometrySearchBD from "../../GeometrySearch/bd/GeometrySearchBD";
import POISearchBD from "../../POISearch/bd/POISearchBD";

declare let BMap: any;

@Component
export default class searchPop extends Vue {
  @Prop({ type: Object }) map!: any;

  private ruleForm: { name: string; region: string; type: string } = {
    name: "",
    region: "",
    type: "POI",
  };
  private areaBtnList: any[] = [
    {
      icon: "circular",
    },
    {
      icon: "square",
    },
    {
      icon: "polygon",
    },
  ];
  private areaActive: number = 0;

  private ClickActive(index: number) {
    this.areaActive = index;
    if (this.ruleForm.type == "POI") {
      this.drawSearchPOI(index);
    } else {
      this.drawGeometrySearch(index);
    }
  }
  private drawGeometrySearch(index: number) {
    let geometrySearch = GeometrySearchBD.getInstance(this.map);
    geometrySearch.clearGeometrySearch();
    let result;
    switch (index) {
      case 0:
        result = geometrySearch.startGeometrySearch({
          drawType: "circle",
          clickHandle: (res: any) => {
            console.log("startGeometrySearch callback:", res);
          },
        });
        break;
      case 1:
        geometrySearch.startGeometrySearch({
          drawType: "rectangle",
        });
        break;
      case 2:
        geometrySearch.startGeometrySearch({
          drawType: "polygon",
        });
        break;
    }
  }
  private drawSearchPOI(index: number) {
    if (this.ruleForm.name == "") {
      return;
    }
    const poi = POISearchBD.getInstance(this.map);
    const drawOverlays = DrawOverlaysBD.getInstance(this.map);
    drawOverlays.deleteDrawOverlays({ types: ["geometrySearch"] });
    poi.clearPOIResults({ types: ["poiSearch"] });
    switch (index) {
      case 0:
        drawOverlays
          .startDrawOverlays({
            drawType: "circle",
            type: "geometrySearch",
            generateId: true,
            showPopup: true,
            onlyOnce: true,
          })
          .then((result: IResult) => {
            let res = result.result;
            poi.searchPOI({
              location: [res.center.lng, res.center.lat],
              searchName: this.ruleForm.name,
              searchType: "circle",
              searchTag: "",
              radius: Math.round(res.radius),
            });
          });
        break;
      case 1:
        drawOverlays
          .startDrawOverlays({
            drawType: "rectangle",
            type: "geometrySearch",
            generateId: true,
            showPopup: true,
            onlyOnce: true,
          })
          .then((result: IResult) => {
            let res = result.result;
            const paths = res.points.map((point: any) => [
              point.lat,
              point.lng,
            ]);
            poi.searchPOI({
              paths,
              searchName: this.ruleForm.name,
              searchType: "rect",
              searchTag: "",
              radius: Math.round(res.radius),
            });
          });
        break;
      case 2:
        drawOverlays
          .startDrawOverlays({
            drawType: "polygon",
            type: "geometrySearch",
            generateId: true,
            showPopup: true,
            onlyOnce: true,
          })
          .then((result: IResult) => {
            let res = result.result;
            const paths = res.points.map((point: any) => [
              point.lat,
              point.lng,
            ]);
            poi.searchPOI({
              paths,
              searchName: this.ruleForm.name,
              searchType: "polygon",
              searchTag: "",
              radius: Math.round(res.radius),
            });
          });
        break;
      case 3:
        break;
    }
  }
  private xzoptions: Array<{ value: string; label: string }> = [
    {
      value: "",
      label: "全部",
    },
    {
      value: "西昌市",
      label: "西昌市",
    },
    {
      value: "雷波县",
      label: "雷波县",
    },
    {
      value: "美姑县",
      label: "美姑县",
    },
    {
      value: "甘洛县",
      label: "甘洛县",
    },
    {
      value: "越西县",
      label: "越西县",
    },
    {
      value: "冕宁县",
      label: "冕宁县",
    },
    {
      value: "喜德县",
      label: "喜德县",
    },
    {
      value: "昭觉县",
      label: "昭觉县",
    },
    {
      value: "金阳县",
      label: "金阳县",
    },
    {
      value: "布拖县",
      label: "布拖县",
    },
    {
      value: "普格县",
      label: "普格县",
    },
    {
      value: "宁南县",
      label: "宁南县",
    },
    {
      value: "会东县",
      label: "会东县",
    },
    {
      value: "会理县",
      label: "会理县",
    },
    {
      value: "德昌县",
      label: "德昌县",
    },
    {
      value: "盐源县",
      label: "盐源县",
    },
    {
      value: "木里藏族自治县",
      label: "木里藏族自治县",
    },
  ];
  private options = [
    {
      value: "POI",
      label: "兴趣点",
    },
    {
      value: "system",
      label: "业务",
    },
  ];
  private closeBtn() {
    (this.$el as any).style.display = "none";
  }
  private startSearch() {
    if (this.ruleForm.type == "POI") {
      if (this.ruleForm.name == "") {
        return;
      }
      this.searchPOI();
    } else {
      this.searchOverlay();
    }
  }
  private clearSearch() {
    if (this.ruleForm.type == "POI") {
      const poi = POISearchBD.getInstance(this.map);
      const drawOverlays = DrawOverlaysBD.getInstance(this.map);
      drawOverlays.deleteDrawOverlays({ types: ["circles"] });
      poi.clearPOIResults({ types: ["poiSearch"] });
    } else {
      let geometrySearch = GeometrySearchBD.getInstance(this.map);
      geometrySearch.clearGeometrySearch();
    }
  }
  private searchOverlay() {
    const geo = GeometrySearchBD.getInstance(this.map);
    geo.startSearchByKey({ key: this.ruleForm.name });
  }
  private searchPOI() {
    const poi = POISearchBD.getInstance(this.map);
    poi.searchPOI({
      searchName: this.ruleForm.name,
      searchPage: 1,
      district: this.ruleForm.region,
      searchType: "region",
    });
  }
}
